import { render, staticRenderFns } from "./ProductProcess.vue?vue&type=template&id=48f1b735&"
import script from "./ProductProcess.vue?vue&type=script&lang=js&"
export * from "./ProductProcess.vue?vue&type=script&lang=js&"
import style0 from "./ProductProcess.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports